import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import leadsData from "./leads.json";
import { getAppSurfaceStyles } from "../theme/siteTheme";

interface Lead {
  name: string;
  telefon: string;
  telefonHref: string;
  email: string;
}
const leads = leadsData as Lead[];

function LeadSection() {
  const theme = useTheme();
  const styles = getAppSurfaceStyles(theme);

  return (
    <Box
      id="lead"
      sx={{
        mb: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
      }}
    >
      <Typography variant="h2" sx={{ mb: 3 }}>
        Ligaleitung
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          width: "100%",
          maxWidth: 600,
          mx: "auto",
        }}
      >
        {leads.map((lead: Lead, idx: number) => (
          <Box
            key={idx}
            sx={{
              ...styles.pageCard,
              borderRadius: 3,
              p: { xs: 2, sm: 3 },
              minWidth: 240,
              width: "100%",
              maxWidth: 500,
              display: "flex",
              flexDirection: "column",
              gap: 1.2,
              alignItems: "flex-start",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "text.primary",
                fontWeight: 700,
                mb: 1,
                textDecoration: "underline",
              }}
            >
              {lead.name}
            </Typography>
            <Typography sx={{ display: "flex", alignItems: "center" }}>
              <Box
                component="span"
                sx={{
                  color: "text.primary",
                  minWidth: 70,
                  display: "inline-block",
                  fontWeight: 600,
                }}
              >
                Telefon:
              </Box>{" "}
              <Link
                href={`tel:${lead.telefonHref}`}
                color="primary"
                underline="always"
              >
                {lead.telefon}
              </Link>
            </Typography>
            <Typography sx={{ display: "flex", alignItems: "center" }}>
              <Box
                component="span"
                sx={{
                  color: "text.primary",
                  minWidth: 70,
                  display: "inline-block",
                  fontWeight: 600,
                }}
              >
                E-Mail:
              </Box>{" "}
              <Link
                href={`mailto:${lead.email}`}
                color="primary"
                underline="always"
              >
                {lead.email}
              </Link>
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default LeadSection;
